// 引入 axios
import axios from "axios";
// 公司
// let base = 'http://192.168.1.38:80/api';
// 线上（万丰官网）
let base = 'http://112.126.76.106:80/api';

// 本地
// let base = 'http://127.0.0.1:80/api';
//传送json格式的get请求
export const getRequest=(url,params)=>{
    return axios({
        method:'get',
        url:`${base}${url}`,
        data: params,
        headers: {
            'Content-Type': 'application/json'
          },
    })
}